import { baseApi } from "./baseApi";
import { tagTypes } from "../tag-types";

const SPECIALTY_URL = '/specialty';

export const specialtyApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSpecialties: build.query({
            query: () => ({
                url: SPECIALTY_URL,
                method: 'GET',
            }),
            providesTags: [tagTypes.specialty],
        }),
        createSpecialty: build.mutation({
            query: (data) => ({
                url: SPECIALTY_URL,
                method: 'POST',
                data,
            }),
            invalidatesTags: [tagTypes.specialty],
        }),
        updateSpecialty: build.mutation({
            query: ({ id, data }) => ({
                url: `${SPECIALTY_URL}/${id}`,
                method: 'PATCH',
                data,
            }),
            invalidatesTags: [tagTypes.specialty],
        }),
        deleteSpecialty: build.mutation({
            query: (id) => ({
                url: `${SPECIALTY_URL}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [tagTypes.specialty],
        }),
    }),
});

export const {
    useGetSpecialtiesQuery,
    useCreateSpecialtyMutation,
    useUpdateSpecialtyMutation,
    useDeleteSpecialtyMutation,
} = specialtyApi;
